class Logger {
  constructor(debug) {
    this.debug = debug;
    this.logStyle = 'color: green; font-weight: bold';
    this.errorLogStyle = 'color: red; font-weight: bold';
  }
  log(message) {
    this.debug && console.log(`%cPacklink Metrics%c ${message}`, this.logStyle, '');
  }
  error(message) {
    this.debug && console.error(`%cPacklink Metrics%c ${message}`, this.errorLogStyle, '');
  }
}

export { Logger };
//# sourceMappingURL=logger.js.map
